"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.BoardCell = void 0;
var GameConstants_1 = require("../../../GameConstants");
var GameVars_1 = require("../../../GameVars");
var BoardCell = /** @class */ (function (_super) {
    __extends(BoardCell, _super);
    function BoardCell(scene, p, appearing) {
        var _this = _super.call(this, scene) || this;
        _this.p = p;
        _this.item = null;
        _this.cellBackground = new Phaser.GameObjects.Image(_this.scene, 0, 0, "texture_atlas_1", GameVars_1.GameVars.gameData.mode === GameConstants_1.GameConstants.GAME_MODE_1 ? "base" : "base_2");
        _this.add(_this.cellBackground);
        _this.markImg = new Phaser.GameObjects.Image(_this.scene, 0, 0, "texture_atlas_1", "base_merge");
        _this.markImg.visible = false;
        _this.add(_this.markImg);
        if (GameConstants_1.GameConstants.SHOW_DEBUG_GEOMETRY) {
            _this.drawDebugGeometry();
        }
        if (appearing) {
            var glowImage_1 = new Phaser.GameObjects.Image(_this.scene, 0, 0, "texture_atlas_1", "radial_new_cake_mistery_box");
            glowImage_1.setScale(0);
            glowImage_1.blendMode = Phaser.BlendModes.SCREEN;
            _this.addAt(glowImage_1, 0);
            _this.scene.tweens.add({
                targets: glowImage_1,
                scaleX: 1.35,
                scaleY: 1.35,
                ease: Phaser.Math.Easing.Cubic.Out,
                duration: 200,
                yoyo: true,
                onComplete: function () {
                    glowImage_1.destroy();
                },
                onCompleteScope: _this
            });
            _this.cellBackground.alpha = 0;
            _this.cellBackground.setScale(.85);
            _this.scene.tweens.add({
                targets: _this.cellBackground,
                alpha: 1,
                scaleX: 1,
                scaleY: 1,
                ease: Phaser.Math.Easing.Back.Out,
                duration: 2000
            });
            var cellBackgroundOverlay = new Phaser.GameObjects.Image(_this.scene, 0, 0, "texture_atlas_1", GameVars_1.GameVars.gameData.mode === GameConstants_1.GameConstants.GAME_MODE_1 ? "base" : "base_2");
            cellBackgroundOverlay.blendMode = Phaser.BlendModes.SCREEN;
            cellBackgroundOverlay.setScale(.85);
            _this.add(cellBackgroundOverlay);
            _this.scene.tweens.add({
                targets: cellBackgroundOverlay,
                alpha: 0,
                scaleX: 1,
                scaleY: 1,
                ease: Phaser.Math.Easing.Back.Out,
                duration: 2000
            });
        }
        return _this;
    }
    BoardCell.prototype.mark = function () {
        this.markImg.visible = true;
    };
    BoardCell.prototype.unmark = function () {
        this.markImg.visible = false;
    };
    BoardCell.prototype.addItem = function (item) {
        if (item.cell) {
            item.cell.item = null;
        }
        this.item = item;
        item.x = 0;
        item.y = BoardCell.ITEM_DELTA_Y;
        this.add(item);
        this.item.cell = this;
        this.onItemOut();
    };
    BoardCell.prototype.removeItem = function () {
        this.item = null;
    };
    BoardCell.prototype.onItemsMerged = function () {
        this.item.merged();
        this.onItemOut();
    };
    BoardCell.prototype.onItemOver = function () {
        this.cellBackground.setFrame(GameVars_1.GameVars.gameData.mode === GameConstants_1.GameConstants.GAME_MODE_1 ? "base_hover" : "base_2_hover");
    };
    BoardCell.prototype.onItemOut = function () {
        this.cellBackground.setFrame(GameVars_1.GameVars.gameData.mode === GameConstants_1.GameConstants.GAME_MODE_1 ? "base" : "base_2");
    };
    BoardCell.prototype.drawDebugGeometry = function () {
        var debugGraphics = new Phaser.GameObjects.Graphics(this.scene);
        debugGraphics.lineStyle(1, 0x0000FF);
        debugGraphics.strokeRect(-BoardCell.BOUNDING_BOX_WIDTH / 2, -BoardCell.BOUNDING_BOX_HEIGHT / 2 + BoardCell.BOUNDING_BOX_Y, BoardCell.BOUNDING_BOX_WIDTH, BoardCell.BOUNDING_BOX_HEIGHT);
        this.add(debugGraphics);
        var cellLabel = new Phaser.GameObjects.Text(this.scene, BoardCell.BOUNDING_BOX_WIDTH * .25, -BoardCell.BOUNDING_BOX_HEIGHT * .475 + BoardCell.BOUNDING_BOX_Y, "c:" + this.p.c + " r:" + this.p.r, { fontFamily: "Arial", fontSize: "12px", color: "#000000" });
        this.add(cellLabel);
    };
    BoardCell.BOUNDING_BOX_WIDTH = 144;
    BoardCell.BOUNDING_BOX_HEIGHT = 156;
    BoardCell.BOUNDING_BOX_Y = -15;
    BoardCell.ITEM_DELTA_Y = -20;
    BoardCell.WIDTH = 160;
    BoardCell.HEIGHT = 170;
    return BoardCell;
}(Phaser.GameObjects.Container));
exports.BoardCell = BoardCell;
